import { track } from '@fff-web/fff-analytics';
import { UPGRADE_TRACK_NAME, UPGRADE_CTA_NAME } from './constants';

const sendUpgradeCompletedEvent = () =>
  track({ trackName: UPGRADE_TRACK_NAME, properties: { cta_name: UPGRADE_CTA_NAME } });

export { sendUpgradeCompletedEvent };
